import api from '../../../services/api';
import { store } from '@/app/store';
import type { User } from '../types/auth.types';

const authPath = '/auth';

export interface LoginRequest {
    email: string;
    password: string;
    device_uuid: string;
    remember_me?: boolean;
}

export interface LoginResponse {
    token: string;
    user: User;
    remember_me?: boolean;
}

export interface LogoutResponse {
    message: string;
}

export interface ForgottenPasswordRequest {
    email: string;
}

export interface ResetPasswordRequest {
    email: string;
    token: string;
    password: string;
    password_confirmation: string;
}

export const login = async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(authPath + '/login', credentials);
    return response.data;
};

export const refresh = async (): Promise<LoginResponse> => {
    const device_uuid = store.getState().device.uuid;
    const remember_me = store.getState().auth.remember_me;
    const response = await api.post<LoginResponse>(authPath + '/refresh', {
        device_uuid: device_uuid,
        remember_me: remember_me,
    });
    return response.data;
};

export const logout = async (): Promise<LogoutResponse> => {
    const response = await api.post<LogoutResponse>(authPath + '/logout');
    return response.data;
};

export const forgottenPassword = async (
    data: ForgottenPasswordRequest
): Promise<LogoutResponse> => {
    const response = await api.post<LogoutResponse>(authPath + '/password/forgot', data);
    return response.data;
};

export const passwordReset = async (data: ResetPasswordRequest): Promise<LogoutResponse> => {
    const response = await api.post<LogoutResponse>(authPath + '/password/reset', data);
    return response.data;
};
